export default "__VITE_PUBLIC_ASSET__8d279316__"